import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";

export default function Orders() {
  const { user, loading } = useAuth();
  const nav = useNavigate();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (!loading && !user) nav("/login");
  }, [loading, user, nav]);

  useEffect(() => {
    if (user) api.get("/bookings/me").then((r) => setOrders(r.data));
  }, [user]);

  if (!user) return null;

  return (
    <div className="min-h-screen px-6 md:px-10 py-14">
      <div className="brand-tag">// Account</div>
      <h1 className="font-display text-5xl uppercase tracking-tight mt-2">My Orders</h1>

      <div className="mt-10 border border-[#E5E1D8] bg-[#FFFFFF]">
        <table className="w-full text-sm font-mono-ds">
          <thead className="border-b border-[#E5E1D8] text-[10px] uppercase tracking-[0.3em] text-[#6E6E6E]">
            <tr>
              <th className="text-left p-4">Booking</th>
              <th className="text-left p-4">Live</th>
              <th className="text-left p-4">Qty</th>
              <th className="text-left p-4">Total</th>
              <th className="text-left p-4">Status</th>
              <th className="text-left p-4">When</th>
            </tr>
          </thead>
          <tbody>
            {orders.length === 0 && (
              <tr><td colSpan={6} className="p-8 text-center text-[#6E6E6E]">// No orders yet. <Link to="/" className="text-[#FF6A00] hover:text-[#161616]">Browse drops →</Link></td></tr>
            )}
            {orders.map((b) => (
              <tr key={b.booking_id} className="border-b border-[#FFFFFF]" data-testid={`my-booking-${b.booking_id}`}>
                <td className="p-4 text-[#161616]">{b.booking_id}</td>
                <td className="p-4 text-[#6E6E6E]"><Link className="hover:text-[#FF6A00]" to={`/live/${b.live_id}`}>{b.live_id}</Link></td>
                <td className="p-4 text-[#161616]">{b.quantity}</td>
                <td className="p-4 text-[#FF6A00] font-bold">₹{b.total}</td>
                <td className="p-4 brand-tag">{b.status}</td>
                <td className="p-4 text-[#6E6E6E] text-[10px]">{new Date(b.created_at).toLocaleString("en-IN")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
